/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AvailableUpdateDto
 */
export interface AvailableUpdateDto {
    /**
     * The name of the version.
     * @type {string}
     * @memberof AvailableUpdateDto
     */
    name: string;
}

/**
 * Check if a given object implements the AvailableUpdateDto interface.
 */
export function instanceOfAvailableUpdateDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function AvailableUpdateDtoFromJSON(json: any): AvailableUpdateDto {
    return AvailableUpdateDtoFromJSONTyped(json, false);
}

export function AvailableUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableUpdateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function AvailableUpdateDtoToJSON(value?: AvailableUpdateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

